import { CSSObject } from '@chakra-ui/react';
import { RaceTableSchema } from '@/views/races/RaceMeetings/RaceTable/styles/RaceTable/RaceTable.styles';

export const raceTableStyles: RaceTableSchema = {
  iconSvgMoneyBackProps: { color: 'gamma.300' },
  afterLinkRaceItemProps: { bg: 'gamma.300' },
};
export const FlexHeadingRow: CSSObject = {};
export const FlexHeading: CSSObject = {
  color: 'white',
  top: ['12', '84px'],
  position: 'unset',
  mb: '0',
};
export const TextHeading: CSSObject = {
  fontFamily: 'Staatliches',
  fontSize: 'sm',
  fontStyle: 'normal',
  fontWeight: 'normal',
  textTransform: 'uppercase',
};
export const IconHeading: CSSObject = {
  boxSize: '8',
  color: 'beta.800',
  bg: 'alpha.400',
  border: 'none',
  borderRadius: 'md',
  path: {
    transform: 'scale(0.6)',
    transformOrigin: 'center',
  },
};
export const BoxPageWrapper: CSSObject = {
  m: '0',
  mb: '4',
  p: '0.5',
  borderRadius: 'lg',
  bgGradient: `linear(to-b, rgba(97, 116, 182, 0.7), rgba(68, 85, 144, 0.7))`,
  boxShadow:
    '0px 1px 5px 0px rgba(130, 151, 222, 1) inset, 0px 4px 8px 0px rgba(0, 0, 0, 0.45)',
};
export const BoxTableWrapper: CSSObject = {
  p: '0',
  bg: 'transparent',
};
export const TextVenueName: CSSObject = {
  fontWeight: 'extrabold',
  color: 'white',
  textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
};
export const TextVenueCountry: CSSObject = {
  fontWeight: 'semibold',
  color: 'alpha.300',
  textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
};
export const TextRaceResults: CSSObject = {
  color: 'white',
};
export const BadgeRaceItem = ({ state }: any): CSSObject => ({
  borderRadius: 'base',
  bg: (() => {
    if (state === 'result') {
      return 'black';
    }
    return 'orange.400';
  })(),
  color: (() => {
    if (state === 'result') {
      return 'white';
    }
    return 'orange.800';
  })(),
});
export const LinkRaceItem = ({
  isToteMultiAvailable,
}: {
  isToteMultiAvailable?: boolean;
}) => ({
  bg: isToteMultiAvailable ? 'alpha.400' : 'transparent',
  borderLeft: 'none',
  borderTop: 'none',
  borderBottom: '1px solid',
  borderBottomColor: isToteMultiAvailable ? '#5C6DA4' : 'whiteAlpha.200',
  borderRightColor: isToteMultiAvailable ? '#5C6DA4' : 'whiteAlpha.200',
  _hover: {
    bg: 'blackAlpha.300',
  },
  _last: {
    borderRight: 'none',
  },
});
export const FlexRow: CSSObject = {
  mb: '0',
  borderRadius: 'none',
  gb: 'transparent',
  _last: {
    borderBottom: 'none',
  },
};
export const FlexButtonWrapper: CSSObject = {
  ml: 'auto',
  flexDir: 'column',
  columnGap: '4',
};
export const BoxVenueName: CSSObject = {
  bg: '#475890',
  py: '1.5',
  borderColor: 'unset',
  borderLeft: 'none',
  borderTop: 'none',
  borderBottom: '1px solid',
  borderRight: '1px solid',
  borderBottomColor: 'whiteAlpha.200',
  borderRightColor: 'whiteAlpha.200',
};
export const CenterTH = () => ({
  bg: 'beta.600',
  color: 'white',
  textAlign: 'center',
  fontSize: '2xs',
  fontStyle: 'normal',
  fontWeight: 'extrabold',
  lineHeight: 'normal',
  py: '2.5',
  borderBottom: '1px',
  borderColor: 'whiteAlpha.200',
  _first: {
    bg: '#47578c',
  },
});
export const ButtonChevron: CSSObject = {
  color: 'beta.800',
  bg: 'alpha.400',
  borderRadius: 'base',
  boxSize: '7',
  width: '7',
  _first: {
    '&&': {
      mb: '0.5',
    },
  },
};
export const BadgeRaceNumber: CSSObject = {
  bg: 'gray.300',
  color: 'gray.600',
  py: '1',
  borderRadius: 'base',
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
};
